import {lazy} from '@aboutyou/lazy-imports';
import {
  BasketPageSkeletonDesktop,
  BasketPendingItemDeletionsProvider,
  usePreloadExpressCheckout,
} from '@aboutyou/logic-components';
import React from 'react';

const NewBasketEager = lazy(
  () =>
    import('./BasketPage.eager').then(mod => ({default: mod.BasketPageEager})),
  {
    fallback: <BasketPageSkeletonDesktop />,
    aboveTheFold: true,
    isSsrAndNeedsHydration: true,
  },
);

export const BasketPage = () => {
  usePreloadExpressCheckout();

  return (
    <BasketPendingItemDeletionsProvider>
      <NewBasketEager />
    </BasketPendingItemDeletionsProvider>
  );
};
